import { Directive, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { distinctUntilChanged, map } from 'rxjs/operators';

import { FullCandidate } from '@recruitee/candidate-types';

@Directive({
  selector: '[rtKiwiHrIntegrationCardGuard]',
  standalone: true,
})
export class KiwiHrIntegrationCardGuardDirective {
  public candidate = input.required<FullCandidate>({ alias: 'rtKiwiHrIntegrationCardGuard' });

  constructor(
    private vcRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
    toObservable(this.candidate)
      .pipe(
        map(candidate => candidate.isHired),
        distinctUntilChanged(),
        takeUntilDestroyed(),
      )
      .subscribe(isHired => {
        if (isHired) {
          this.vcRef.createEmbeddedView(this.templateRef);
        } else {
          this.vcRef.clear();
        }
      });
  }
}
